import { NavigateFunction } from 'react-router-dom';

interface NavigationWithScrollOptions {
  /**
   * Whether to use smooth scrolling animation
   * @default true
   */
  smooth?: boolean;
  /**
   * Delay before scrolling (useful for pages with loading states)
   * @default 0
   */
  delay?: number;
  /**
   * Offset from top of page (useful if you have a fixed header)
   * @default 0
   */
  offset?: number;
  /**
   * Navigation options to pass to React Router
   */
  navigationOptions?: any;
}

/**
 * Navigate to a path and scroll to top of the page
 * @param path - Path to navigate to
 * @param navigate - React Router navigate function
 * @param options - Scroll and navigation options
 */
export const handleNavigationWithScroll = (
  path: string,
  navigate: NavigateFunction,
  options: NavigationWithScrollOptions = {}
): void => {
  const {
    smooth = true,
    delay = 0,
    offset = 0,
    navigationOptions = {}
  } = options;

  navigate(path, navigationOptions);
  
  const scrollToTop = () => {
    if (typeof globalThis !== 'undefined' && globalThis.window) {
      globalThis.window.scrollTo({
        top: offset,
        left: 0,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  };

  if (delay > 0) {
    setTimeout(scrollToTop, delay);
  } else {
    scrollToTop();
  }
};

/**
 * Simple scroll to top function
 * @param options - Scroll options
 */
export const scrollToTop = (options: Omit<NavigationWithScrollOptions, 'navigationOptions'> = {}) => {
  const {
    smooth = true,
    offset = 0
  } = options;

  if (typeof globalThis !== 'undefined' && globalThis.window) {
    globalThis.window.scrollTo({
      top: offset,
      left: 0,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }
};
